import * as React from 'react';

import { cn } from 'src/utils/shadcn';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';

function Input({ className, type, moreInfo, ...props }: React.ComponentProps<'input'> & { moreInfo?: string }) {
    return (
        <div className={cn('w-full', moreInfo && 'relative')}>
            <input
                type={type}
                data-slot="input"
                className={cn(
                    'file:text-foreground plaeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input flex h-10 w-full min-w-0 rounded-md border bg-white px-4 py-2 shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none',
                    'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                    'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
                    className,
                )}
                {...props}
            />
            {moreInfo && (
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger
                            asChild
                            className="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer pl-2"
                        >
                            <FontAwesomeIcon
                                icon={faCircleQuestion}
                                className="text-muted-foreground stroke-current stroke-[1px] text-[14px]"
                            />
                        </TooltipTrigger>
                        <TooltipContent className="flex min-h-18 flex-row items-center text-left sm:max-w-lg sm:gap-2">
                            <>
                                <FontAwesomeIcon icon={faCircleQuestion} className="text-[14px] text-gray-600" />
                                <div className="text-sm text-gray-600">{moreInfo}</div>
                            </>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            )}
        </div>
    );
}

export { Input };
